// GLOBAL CUSTOM COMPONENTS
import { FlexBetween } from "src/lib/components/salify-next-layout/default/components/flex-box";
import {
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography"; // CUSTOM UTILS LIBRARY FUNCTION
import { formatMoney } from "src/lib/utils";

// ==============================================================
const CartItem = ({ name, price, qty }) => (
  <FlexBetween mb={1.5}>
    <Paragraph>
      <Span fontWeight="700">{qty}</Span> x {name}
    </Paragraph>

    <Paragraph>{formatMoney(price)}</Paragraph>
  </FlexBetween>
);

export default CartItem;
